import { IPageLayoutProps } from "../../IConfiguration";
import * as React from 'react';
import * as classNames from "classnames";
import Header from "../../../../Header";
import SidebarLogo from "../../../../SidebarLogo";
import { withTheme } from "../../../../../common/withTheme";
import MenuItemList from "../../../MenuItems";
import Menu from "../../../Menu";
import MapLegend from "../../../../Map/MapLegend";
import Collapse from "../../../../Common/Collapse";

class PageLayoutDashboard extends React.Component<IPageLayoutProps, any> {
    constructor(props, context) {
        super(props, context);
    }

    render() {

        const menu = MenuItemList(this.props.pages, this.props.currentUser, "list-group-item list-group-item-nav list-group-item-action clickable");

        const testEnvironment = this.props.websiteSettings ? this.props.websiteSettings.testEnvironment : false;

        return (
            <div className={classNames(this.props.theme, "page-container", { "test-environment": testEnvironment })} >
                <Header
                    className={"d-none"}
                    bannerName={"Australian Platypus Monitoring Network"}
                    currentUser={this.props.currentUser}
                    loginActive={this.props.loginActive}
                    userButtonClassnames={"btn-outline-light"}
                />
                <div className="fixed-content row flex-md-row flex-column no-gutters">
                    <div className={classNames(this.props.theme, "sidebar col-auto col-xl-2 col-md-3 d-flex flex-row flex-md-column justify-content-start px-3")}>
                        <Menu className="list-group rounded shadow bg-white">
                            {menu}
                        </Menu>
                        {/*
                            this.props.generateSideBar ?
                                <Collapse
                                    title="Filters"
                                >
                                    <FilterSearch
                                        classificationFilter={undefined}
                                        currentUser={this.props.currentUser}
                                        onFilterChanged={undefined}
                                        showFilters={undefined}
                                        queryDateStart={undefined}
                                        queryDateEnd={undefined}
                                        queryCommunityGroupId={undefined}
                                    />
                                </Collapse> : null
                        */}

                        {
                            this.props.generateLegendFindings || this.props.generateLegendSiteSelect ?
                                <Collapse
                                    buttonClassName="mb-1"
                                    title="Legend"
                                >
                                    <MapLegend
                                        siteSelect={this.props.generateLegendSiteSelect}
                                    />
                                </Collapse> : null
                        }
                        <SidebarLogo display={true} />
                    </div>
                    <div className={classNames(this.props.theme, "content-section col")} >
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}


export default withTheme<IPageLayoutProps>(PageLayoutDashboard);